<script>
	import Helper from './components/Helper.svelte';
	import Permisos from './componentes/Permisos.svelte';
	
	import Input from './componentes/Forms/Input.svelte';
	import Modal from './components/Modal.svelte';
	import Titlesection from './components/Titlesection.svelte';
	import AnimationContainer from './components/AnimationContainer.svelte';
	import Navbar from './components/Navbar.svelte';
    import { push } from 'svelte-spa-router';
    import { urlapi, permisos, permisos_struct,permisos_title,miPermiso,iduser,login, sucursalStore } from './stores/store';
    import { object2array, postData, isJson, mergeDeep } from './scripts';

    export let params = {}

    /* PERMISOS */
    let viewPage=false;

    if($login===false)
    {
        push('/login')
    } else if(
                $miPermiso.sucursales.access===false
                || ($miPermiso.sucursales.edit!==true && parseInt(params.id)!==0)
            ) {
        push('/sinpermiso')
    } else {
        viewPage=true;
    }
    /* FIN PERMISOS */

    // campos
    let sucursalActiva=false;
    let id=false;
    let nombre='';
    let comercial='';
    let establecimiento='';
    let direccion='';
    let municipio='';
    let departamento='';
    let cp='';

    let helper=false;
    
    // status
    let disabled=false;
    let guardando=false;
    let insertando=false;

    let function_salir = function () { push('/sucursales'); }

    let save=async function()
    {
            disabled=true;
            guardando=true;

            const res = await postData($urlapi, [{ 
                id,
                nombre,
                comercial,
                establecimiento,
                direccion,
                municipio,
                departamento,
                cp,
                'activo':sucursalActiva,
                'cmd':'sucursales_save' 
            }])
            .then(data => {
                guardando=false;
                disabled=false;

                postData($urlapi, [{ 'cmd':'sucursales_listAll' }])
                .then(data => {
                    $sucursalStore={}
                    Object.values(data[0].result).map(function(value) {
                        $sucursalStore={...$sucursalStore,[value.id] :value.nombre}
                    });
                    function_salir();
                });                
                
            });
    }


    let load=function()
    {
        postData($urlapi, [{ 'id':id, 'cmd':'sucursales_editar' }])
        .then(data => {
            if(data[0].result===false) {
                function_salir();
            } else {
                nombre=data[0].result.nombre
                comercial=data[0].result.comercio
                establecimiento=data[0].result.establecimiento
                direccion=data[0].result.direccion
                municipio=data[0].result.municipio
                departamento=data[0].result.departamento
                cp=data[0].result.cp
                sucursalActiva=(data[0].result.activo=='1')?true:false;
            }
        });   
    }
    if(params.id!=0)
    {
        insertando=false;
        id=params.id;
        load();
    } else {
        function_salir();
    }        

</script>

{#if viewPage===true}

<Navbar />

<AnimationContainer marginTop=0>
    <Titlesection>
        <span slot="title"><i class="bi bi-shop me-1" />Sucursales
        <small class='badge bg-light text-success text-uppercase'>
        {#if insertando===true}
            Nuevo
        {:else}
            ID {id}
        {/if}
        </small>
        
        </span>
        <span slot="toolbar">

            <button {disabled} class="btn btn-success" on:click={save}  on:mouseenter={()=>helper='Guardar'} on:mouseleave={()=>helper=false}>
                {#if guardando===true}
                    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                {/if}
                <i class="bi bi-save"></i></button>
            <Modal classButton='btn-warning btn-sm' iconButton='bi-box-arrow-left' functionSi={function_salir} title='ADVERTENCIA' {disabled}  on:mouseenter={()=>helper='Salir'} on:mouseleave={()=>helper=false}>
                Esta seguro que desea <strong>Salir</strong>?<br/>
                Se perderán los cambios realizados
            </Modal>                
        </span>
    </Titlesection>

    <br/>
    <div class="row">
        <div class="col-12 col-md-6">

            <h6 class='fw-bold text-uppercase text-warning'>Datos de Sucursal</h6>
            <div><Input label='Nombre' bind:value={nombre} class='mb-2' {disabled}/></div>

            <h6 class='fw-bold text-uppercase text-warning mt-4'>Datos de facturación</h6>

            <div><Input label='Nombre Comercial' bind:value={comercial} class='mb-2' {disabled}/></div>
            <div><Input label='Establecimiento' bind:value={establecimiento} class='mb-2' {disabled}/></div>
            <div><Input label='Dirección' bind:value={direccion} class='mb-2' {disabled}/></div>
            <div><Input label='Municipio' bind:value={municipio} class='mb-2' {disabled}/></div>
            <div><Input label='Departamento' bind:value={departamento} class='mb-2' {disabled}/></div>
            <div><Input label='Código Postal' bind:value={cp} class='mb-2' {disabled}/></div>

            <br/><br/>
        </div>
        <div class="col-12 col-md-6">
            <h6 class='fw-bold text-uppercase text-warning'>ESTADO</h6>
            
            <div class="row">
                <div class="col-sm-10">
                    <div class="form-check form-switch mt-2">
                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefaultVisible" bind:checked={sucursalActiva} disabled={disabled} >
                        <label class="form-check-label text-muted" for="flexSwitchCheckDefaultVisible">Sucursal Activa</label>
                    </div>                            
                </div>
            </div>
        </div>
    </div>

    <Helper bind:text={helper}></Helper>
</AnimationContainer>

{/if}